<template>
  <div>
    <a-drawer
      :title="memberDiaTit"
      :width="720"
      :visible="visible"
      :mask-closable="false"
      wrap-class-name="filter-drawer-group"
      @close="handleCancel"
    >
      <section class="dialog-title-section">
        <!-- <a-icon type="user" /> -->
        <span>
          <i class="iconfont iconicon-test28 user" />
          {{ users.truename }}
        </span>
      </section>
      <a-form :form="form">
        <a-form-item
          :label="roleTitTxt"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-select
            v-decorator="['roleid',{rules: [{ required: true, message: selectRolePlace }]}]"
            :placeholder="selectRolePlace"
            class="margin-left-16"
            :disabled="forbiddenRole!==1?true:false || users.isOnly"
            @change="handleChange"
          >
            <a-select-option
              v-for="(items,indexs) in rolesArray"
              :key="`${items.roleid}_${indexs}`"
              :value="items.roleid"
            >
              {{ items.rolename }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          v-if="!isChecker"
          :label="teamGroupTit"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-select
            v-if="isGroup"
            v-decorator="['groupid',{rules: [{ required: !isGroup, message: selectGroupPlace }]}]"
            mode="multiple"
            :allow-clear="true"
            class="second-seclect margin-left-16"
            :placeholder="selectGroupPlace"
            @change="handleChangeSelectGroup($event)"
          >
            <a-select-opt-group
              v-for="(itemgroup,indexs) in remainGroupArr"
              :key="`0_${itemgroup.groupid}_${indexs}`"
              :label="itemgroup.teamname"
            >
              <template v-if=" 'groups' in itemgroup && itemgroup.groups.length > 0">
                <a-select-option
                  v-for="(itemoptgroup,indexg) in itemgroup.groups"
                  :key="`${itemoptgroup.groupid}_${indexg}`"
                  :value="itemoptgroup.groupid"
                >
                  {{ itemoptgroup.groupname }}
                </a-select-option>
              </template>
            </a-select-opt-group>
          </a-select>
          <a-select
            v-else
            v-decorator="['groupid',{rules: [{ required: true, message: selectGroupPlace }]}]"
            mode="multiple"
            class="margin-left-16"
            :placeholder="selectGroupPlace"
          >
            <template>
              <a-select-option
                v-for="(item,index) in remainGroupArr"
                :key="`group_${index}`"
                :value="item.groupid"
              >
                {{ item.groupname }}
              </a-select-option>
            </template>
          </a-select>
        </a-form-item>
        <a-form-item
          v-if="!$isDingDing"
          :label="`${mobileTit}：`"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input
            disabled
            class="margin-left-16"
            :value="users.mobile"
          />
        </a-form-item>
        <a-form-item
          v-if="!$isDingDing"
          :label="emailTit"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input
            disabled
            class="margin-left-16"
            :value="users.email"
          />
        </a-form-item>
        <a-form-item
          v-if="!$isDingDing"
          :label="qwTitTxt"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <span
            v-if="users.bind_qiwei===0"
            class="s-info"
            style="margin-left:16px;"
          >{{ $t('message["1260"]') }}</span>
          <span
            v-else
            class="margin-left-16"
          >
            <template v-if="users.bindQiweiInfo && users.bindQiweiInfo.length">
              <div class="user-list">
                <div
                  v-for="item in users.bindQiweiInfo "
                  :key="item.id"
                  class="user-item"
                >
                  <!-- <span>{{ item.name }}</span> -->
                  <div class="">
                    <span
                      v-if="$store.state.qwWork === 'isWxWork'"
                      class="iframe-qw-name"
                    >{{ item.userid }}</span>
                    <iframe
                      v-else
                      class="iframe-qw-name"
                      :src="item.iframeUrl"
                      scrolling="no"
                    />
                    <div
                      v-if="item.corp_full_name"
                      class="s-info account-tit-name"
                    >
                      {{ item.corp_full_name }}
                    </div>
                  </div>
                </div>
              </div></template>
          </span>
        </a-form-item>
        <!-- 钉钉 -->
        <a-form-item
          v-if="$isDingDing"
          :label="dingdingTxt"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <span
            v-if="users.bind_dingding===0"
            class="s-info"
            style="margin-left:16px;"
          >{{ $t('message["1260"]') }}</span>
          <div
            v-else
            class="row-cell-content"
          >
            <template v-if="users.bindDingdingInfo">
              <span>{{ users.bindDingdingInfo.name }}</span>
              <div
                v-if="users.bindDingdingInfo.corp_full_name"
                class="s-info account-tit-name"
              >
                {{ users.bindDingdingInfo.corp_full_name }}
              </div>
            </template>
          </div>
        </a-form-item>
        <a-form-item
          v-if="!$isDingDing"
          :label="gcTitTxt"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <span
            v-if="users.bind_gcw===0"
            class="s-info"
            style="margin-left:14px;"
          >{{ $t('message["1260"]') }}</span>
          <div
            v-else
            class="row-cell-content"
          >
            <template v-if="users.bindGcwInfo">
              <span>{{ users.bindGcwInfo.name }}</span>
              <div
                v-if="users.bindGcwInfo.comname"
                class="s-info account-tit-name"
              >
                {{ users.bindGcwInfo.comname }}
              </div>
            </template>
          </div>
        </a-form-item>
      </a-form>
      <div class="foot-btn-div">
        <a-button
          type="primary"
          :disabled="!(roleTeamEditMember||configGroupEditMember)"
          class="save-btn"
          @click="handleOk"
        >
          {{ $t('message["21"]') }}
        </a-button>
        <a-button
          :style="{marginRight: '8px'}"
          class="cancel-btn"
          @click="handleCancel"
        >
          {{ $t('message["896"]') }}
        </a-button>
        <a-button
          v-show="!users.isOnly"
          :disabled="!(roleTeamDeleteMember||configGroupDeleteMember)"
          class="delete-btn"
          @click="handleDelete"
        >
          {{ $t('message["962"]') }}
        </a-button>
      </div>
    </a-drawer>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
  props: {
    dialogData: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      visible: false,
      isGroup: false,
      rolesArray: [],
      isChecker: false,
      remainGroupArr: [],
      roleTeamEditMember: false,
      roleTeamDeleteMember: false,
      configGroupEditMember: false,
      configGroupDeleteMember: false,
      users: {
        truename: '',
        roleInfo: [],
        groupInfo: [],
        email: '',
        mobile: 'null',
        bind_qiwei: 0,
        bind_gcw: 0,
        bind_dingding: 0,
        isOnly: false
      },
      formLayout: 'horizontal',
      form: this.$form.createForm(this)
    }
  },
  computed: {
    ...mapState('role', ['roleDataList']),
    ...mapState('team/manage', ['selectTreenDataKey', 'permmissionLists', 'tableDatas']),
    ...mapState('team/member', ['memberVisible', 'forbiddenRole', 'groupList2', 'memberLoading', 'userInfo']),
    isOnlyPrincipal () {
      let members = this.tableDatas.filter((member, index) => {
        const [role] = member.roleinfo
        return Number(role.system_role) === 1
      })
      return members.length === 1
    },
    memberDiaTit () {
      return this.$t('message["114"]')
    },
    dingdingTxt () {
      return this.$t('message["238"]')
    },
    gcTitTxt () {
      return this.$t('message["391"]')
    },
    roleTitTxt () {
      return this.$t('message["503"]')
    },
    qwTitTxt () {
      return this.$t('message["720"]')
    },
    selectRolePlace () {
      return this.$t('message["869"]')
    },
    selectGroupPlace () {
      return this.$t('message["880"]')
    },
    mobileTit () {
      return this.$t('message["1107"]')
    },
    teamGroupTit () {
      return this.$t('message["1159"]')
    },
    emailTit () {
      return this.$t('message["1505"]')
    }
  },
  watch: {
    permmissionLists (val) {
      if (val) {
        this.roleTeamEditMember = val['role-team-edit-member']
        this.roleTeamDeleteMember = val['role-team-delete-member']
        this.configGroupEditMember = val['config-group-edit-member']
        this.configGroupDeleteMember = val['config-group-delete-member']
      }
    },
    memberVisible (val) {
      this.visible = val
    },
    groupList2 (val) {
      if (!val) return
      this.remainGroupArr = val
    },
    userInfo (val) {
      if (!val) {
        return
      }
      this.users = val
      const [role] = val.roleInfo
      if (role) {
        this.setGroupAndCheck(role)
        // 再次判断是否为唯一负责人
        Object.assign(this.users, this.delPrincipal(role))
      }
      // console.log(this.users)
      let defaultRoleValue = []
      let defaultGroupValue = []
      if (Array.isArray(val.roleInfo)) {
        val.roleInfo.map(value => {
          defaultRoleValue.push(value.roleid)
        })
      }
      if (Array.isArray(val.groupInfo)) {
        val.groupInfo.map(value => {
          defaultGroupValue.push(value.groupid)
        })
      }
      this.form.getFieldDecorator('roleid', { initialValue: defaultRoleValue, preserve: true })
      this.form.getFieldDecorator('groupid', { initialValue: defaultGroupValue, preserve: true })
    },
    roleDataList (val) {
      if (!val) return
      this.rolesArray = val
    }
  },
  async created () {
    if (this.memberVisible) {
      this.changMemberVisible({ state: false })
    }
    const chain = await this.fetchGetRoleDatas({ status: 1 })
    chain.fetch()
  },
  methods: {
    ...mapActions('role', ['fetchGetRoleDatas']),
    ...mapActions('team/member', ['fetchGetGroups2', 'changMemberVisible', 'changMemberLoading', 'fetchDeleteMember', 'fetchEditMemberInfo']),
    onChange (value) {
      this.value = value
    },
    // 成员管理---保存操作
    handleOk (e) {
      const _this = this
      _this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          const params = {
            userid: _this.users.userid,
            ...values
          }
          if (_this.isChecker === true) {
            params.groupid = []
          }
          if (Array.isArray(params.roleid)) {
            params.roleid = params.roleid[0]
          }
          const chain = await _this.fetchEditMemberInfo(params)
          chain.onSuccess(raw => {
            if (!_this.memberVisible) {
              _this.form.resetFields('roleid')
              _this.form.resetFields('groupid')
            }
          })
            .onFail((err, all) => {
              const { message } = all
              if (err === 103) {
                _this.$message.error(message)
                _this.changMemberVisible({ state: false })
              } else {
                _this.deleteNotification({ key: err, desc: message, title: this.$t('message["42"]'), userid: _this.users.userid })
              }
              // _this.form.resetFields('roleid')
              // _this.form.resetFields('groupid')
            }).fetch()

          _this.isChecker = false
          _this.isGroup = false
          _this.fetchGetGroups2({ roleid: _this.form.getFieldValue('roleid'), userid: _this.users.userid })
        }
      })
    },
    handleChangeSelectGroup (val, item) {
    },
    handleChange (val) {
      this.isGroup = false
      this.isChecker = false
      // this.form.setFieldsValue({ groupid: [] })
      this.rolesArray.some(value => {
        if (val === value.roleid) {
          if (value.system_role) {
            if (value.system_role * 1 === 1) {
              this.isGroup = true
            } else {
              this.form.setFieldsValue({ groupid: [] })
            }
            if (value.system_role * 1 === 2) {
              this.isChecker = true
              this.form.resetFields('groupid')
            }
          }
          return true
        }
      })
      if (this.isChecker) {
        return
      }
      this.fetchGetGroups2({ roleid: val, userid: this.users.userid })
    },
    // 取消操作
    handleCancel () {
      this.isChecker = false
      this.isGroup = false
      this.form.resetFields('roleid')
      this.form.resetFields('groupid')
      this.changMemberVisible({ state: false })
      this.changMemberLoading(false)
    },
    setGroupAndCheck (val) {
      this.rolesArray.some(value => {
        if (val.system_role * 1 === value.system_role * 1) {
          if (val.system_role * 1 === 1) {
            this.isGroup = true
          } else if (val.system_role * 1 === 2) {
            this.isChecker = true
          } else {
            this.isChecker = false
            this.isGroup = false
          }
          return true
        }
      })
    },
    // 删除成员以及二次确认操作
    handleDelete (e) {
      const that = this
      this.$confirm({
        title: <div><a-tag>{this.users.truename}</a-tag>{ this.$t('message["480"]')}</div>,
        closable: true,
        iconType: 'exclamation-circle',
        content: this.$t('message["1521"]') + '？',
        okText: this.$t('message["915"]'),
        cancelText: this.$t('message["896"]'),
        async onOk () {
          that.isChecker = false
          that.isGroup = false
          that.changMemberVisible({ state: false })
          const chain = await that.fetchDeleteMember(that.users.userid)
          chain.onFail((err, all) => {
            const { message } = all
            if (err === 103) {
              that.$message.error(message)
            } else {
              that.deleteNotification({ key: err, desc: message, title: that.$t('message["975"]'), userid: that.users.userid })
            }
          })
            .fetch()
          that.form.resetFields('roleid')
          that.form.resetFields('groupid')
        }
      })
    },
    delPrincipal (role) {
      let obj = {}
      if (role.system_role * 1 === 1 && this.isOnlyPrincipal) {
        Object.assign(obj, { isOnly: true })
      } else {
        Object.assign(obj, { isOnly: false })
      }
      return obj
    },
    deleteNotification ({ key, desc, title, userid }) {
      const btn = <div class='no-btns'>
        <a-button type="primary" size="small" onClick={() => this.toResgin(userid, key)}>{this.$t('message["598"]')}</a-button>
        <a-button size="small" onClick={() => this.colseNotification(key)}>{this.$t('message["1004"]') }</a-button>
      </div>
      let aDesc = desc.split('，')
      let vNodeDesc = <p><span style="color: #ee817f">{aDesc[0]}</span>, {aDesc[1]}</p>
      this.$notification['warning']({
        message: title,
        description: vNodeDesc,
        btn,
        key,
        class: 'regsin-notification'
      })
    },
    // 前往离职交接
    toResgin (user, key) {
      this.$router.push({ name: 'quit', query: { userid: user } })
      this.colseNotification(key)
    },
    colseNotification (key) {
      this.$notification.close(key)
    }
  }
}
</script>
<style lang="scss" scoped>
.margin-left-16 {
  margin-left: 16px;
}
.dialog-title-section {
  margin-bottom: 25px;
  margin-left: 24px;
  margin-top:-24px;
  .user {
    font-size: 32px;
    color: #c0c4cc;
    vertical-align: middle;
    margin-right: 4px;
    margin-top: -4px;
    display: inline-block;
  }
  span {
    margin-top: 4px;
    height: 40px;
    line-height: 40px;
    font-size: 20px;
    display: inline-block;
  }
}
.s-info {
  color: #c0c4cc;
  margin-left: 5px;
}
.foot-btn-div {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: left;
  .cancel-btn {
    &:hover {
      border-radius: 4px;
      box-shadow: inset 0 2px 0 0 rgba(255, 255, 255, 0.5);
      border: solid 1px #ebebeb;
      background-color: #ffffff;
    }
  }
  .save-btn {
    margin-left: 188px;
  }
  .delete-btn {
    margin-left: 8px;
    color: #fff;
    background-color: #f57676;
    &:hover {
      background-color: #f55d5d;
    }
  }
}
.row-cell-content{
    line-height: 24px;
    padding-top: 4px;
    margin-left: 16px;
    .s-info {
      margin-left: 0;
    }
  }
 .account-tit-name {
    padding-top: 8px;
  }
.user-list::v-deep {
    margin-bottom: -8px;
    display: inline-block;
    //margin-top: -6px;
   .user-item {
      padding-top: 4px;
      line-height: 24px;
      padding-bottom: 12px;
      box-sizing: content-box;
      .iframe-qw-name {
        display: inline;
        height: 24px;
        vertical-align: middle;
        width: 400px;
        border: 0;
      }
      .s-info {
        margin-left: 0;
      }
    }
  }
</style>
<style lang="scss">
.regsin-notification {
  .ant-notification-notice-btn {
    float: left;
    margin-left: 45px;
  }
}
</style>
